import React from "react";
export const handle = () => {
  return (
    <div className="opinion-wrap">
      <h1>收到信访事项后，信访部门是如何处理的？</h1>
      <div className="text-cont">
        根据《信访工作条例》有关规定，信访部门对受理的信访事项，按照“属地管理、分级负责，谁主管、谁负责”的原则，转送、交办有权处理的单位、部门，依法按政策办理；对信访事项已经受理或者正在办理的，信访人在规定期限内又提出同一信访事项的，以及不服复核意见，仍然以同一事实和理由提出诉求的，出具相应告知。
      </div>

      <br />
    </div>
  );
};
